import { STAGES, FLOWS, SECTORS } from "./constants";

export const Step2 = ({ f, setF, toggle, valid, onBack, onNext }) => (
  <div className="rise">
    <h1 className="text-4xl sm:text-5xl mt-4 text-bone" style={{ fontWeight: 500 }}>Investment preferences</h1>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Startup stages</h2>
      <p className="t-small text-muted-s mt-2">Stages reflect a startup's maturity, shaping its risk and return profile.</p>
      <div className="mt-4 space-y-3">
        {STAGES.map((s) => (
          <button key={s.id} className={`option-card flex justify-between gap-6 ${f.stages.includes(s.id) ? "selected" : ""}`}
            onClick={() => toggle("stages", s.id)} data-testid={`onboarding-stage-${s.id.replace(/[^a-z]/gi, "-").toLowerCase()}`}>
            <span>
              <span className="t-body block">{s.id}</span>
              <span className="t-small text-muted-s block mt-1">{s.desc}</span>
            </span>
            <span className="t-label whitespace-nowrap">{s.risk}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Deal flow</h2>
      <p className="t-small text-muted-s mt-2">Control the volume of opportunities shown to you, based on the investors in each underlying round.</p>
      <div className="mt-4 space-y-3">
        {FLOWS.map((fl) => (
          <button key={fl.id} className={`option-card flex justify-between gap-6 ${f.deal_flow === fl.id ? "selected" : ""}`}
            onClick={() => setF({ ...f, deal_flow: fl.id })} data-testid={`onboarding-flow-${fl.id}`}>
            <span>
              <span className="t-body block">{fl.label}</span>
              <span className="t-small text-muted-s block mt-1">{fl.desc}</span>
            </span>
            <span className="t-label whitespace-nowrap">{fl.vol}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="mt-12">
      <div className="flex items-baseline justify-between gap-6">
        <h2 className="t-h2 text-bone">Sectors</h2>
        <div className="flex gap-4">
          <button className="t-label hover:!text-[#E8E6E1]" onClick={() => setF({ ...f, sectors: [...SECTORS] })} data-testid="sectors-select-all">Select all</button>
          <button className="t-label hover:!text-[#E8E6E1]" onClick={() => setF({ ...f, sectors: [] })} data-testid="sectors-clear-all">Clear all</button>
        </div>
      </div>
      <p className="t-small text-muted-s mt-2">Deals outside these sectors are not shown to you.</p>
      <div className="mt-4 grid grid-cols-2 gap-x-6" data-testid="sectors-grid">
        {SECTORS.map((s) => (
          <button key={s} onClick={() => toggle("sectors", s)}
            className="flex items-center gap-3 py-2 text-left group"
            data-testid={`sector-${s.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
            <span className="inline-block w-4 h-4 border flex-shrink-0"
              style={{ borderColor: f.sectors.includes(s) ? "var(--bone)" : "var(--rule)", background: f.sectors.includes(s) ? "var(--bone)" : "transparent" }} />
            <span className={`t-small ${f.sectors.includes(s) ? "text-bone" : "text-muted-s"} group-hover:text-bone transition-colors duration-150`}>{s}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="flex gap-3 mt-12">
      <button className="btn-ghost" onClick={onBack} data-testid="onboarding-back-button">Back</button>
      <button className="btn-primary flex-1" disabled={!valid}
        onClick={onNext} data-testid="onboarding-next-2-button">Continue</button>
    </div>
  </div>
);
